import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { ToastService } from 'src/app/core/toast.service';
import { combineLatest } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { GET_REGISTERED_COUNT, getAllCoursedata, getRelatedCourse, getSelectedCourse } from '../queries/learning-hub.query';

@Injectable({
  providedIn: 'root',
})

export class LearningHubService {
  constructor(private apollo: Apollo, private toast: ToastService) { }



  getCourseByid(id: string, userId: string) {
    return this.apollo.use('external').query({
      query: getSelectedCourse,
      variables: { id, userId },
      fetchPolicy: 'network-only'
    }).pipe(pluck('data', 'courses_by_pk'));
  }



  getAllRelatedCourse(limit: number, offset: number, type?: string, status?: string, active_status?: string, id?: string, communityId?: string, isStatic?: boolean) {

    const where: any = {
      _and: [
        { type: { _eq: type } },
        { active_status: { _eq: active_status } },
        { status: { _eq: status } },
        { id: { _neq: id } }, // Exclude the course with matching ID
      ],
    };

  if (isStatic) {
    // When coming from static source → only BOTH filter
    where._and.push({ community_user_type: { _eq: 'BOTH' } });
  } else if (communityId) {
    // When not static and communityId exists → community_id filter
    where._and.push({ community_id: { _eq: communityId } });
  }

    return this.apollo.use("external").query({
      query: getRelatedCourse,
      variables: {
        limit,
        offset,
        where
      },
      fetchPolicy: 'network-only',
    }).pipe(pluck('data', 'courses'));
  }


 
   getAllLearningHubData(
    limit: number,
    offset: number,
    search?: string,
    extraFilters?: {
      type?: string[];
      categoryIds?: string[];
      start_date?: string | null;
      address?: string,
      communities?: string[];
    },
    JoinCommunityIds?: string[],
    loginId?: string

  ): Observable<any[]> {

    const where: Record<string, any> = { _and: [] };

    // Search filter 
    const trimmedSearch = search?.trim();
    if (trimmedSearch) {
      where._and.push({
        _or: [
          { company_name: { _ilike: `%${trimmedSearch}%` } },
          { course_name: { _ilike: `%${trimmedSearch}%` } },
          { presented_by_name: { _ilike: `%${trimmedSearch}%` } }
        ]
      });
    }

    // Communities filter (guard extraFilters)
    if (extraFilters?.communities?.length) {
      where._and.push({ community_id: { _in: extraFilters.communities } });
    } else if (loginId) {
      // preserve existing conditions by pushing the login-based _or block into _and
      where._and.push({
        _or: [
          // Case 1: Own courses (COMMUNITY_USER + BOTH + null) OR joined community
          {
            _and: [
              { created_by_id: { _eq: loginId } },
              {
                _or: [
                  { community_user_type: { _in: ["COMMUNITY_USER", "BOTH"] } },
                  { community_user_type: { _is_null: true } },
                  // guard JoinCommunityIds (may be undefined)
                  ...(JoinCommunityIds?.length ? [{ community_id: { _in: JoinCommunityIds } }] : [])
                ]
              }
            ]
          },
          // Case 2: Others' courses (BOTH + null) OR joined community
          {
            _and: [
              { created_by_id: { _neq: loginId } },
              {
                _or: [
                  { community_user_type: { _eq: "BOTH" } },
                  { community_user_type: { _is_null: true } },
                  ...(JoinCommunityIds?.length ? [{ community_id: { _in: JoinCommunityIds } }] : [])
                ]
              }
            ]
          }
        ]
      });
    }

    // Type filter
    if (extraFilters?.type?.length) {
      where._and.push({ type: { _in: extraFilters.type } });
    }

    // Category filter
    if (extraFilters?.categoryIds?.length) {
      where._and.push({ course_category_id: { _in: extraFilters.categoryIds } });
    }

    // Start date filter
    if (extraFilters?.start_date) {
      where._and.push({ startDate: { _eq: extraFilters.start_date } });
    }

    // Address filter
    const trimmedAddress = extraFilters?.address?.trim();
    if (trimmedAddress) {
      where._and.push({
        address: { _cast: { String: { _ilike: `%${trimmedAddress}%` } } }
      });
    }

    // If no conditions were added, send empty object instead of { _and: [] }
    const finalWhere = (where._and && where._and.length) ? where : {};

    return this.apollo.use("external").query({
      query: getAllCoursedata,
      variables: { limit, offset, where: finalWhere },
    }).pipe(pluck('data', 'courses'));
  }




  getRegisteredCount(courseId: string) {
    return this.apollo.use('external').query({
      query: GET_REGISTERED_COUNT,
      variables: { courseId },
      fetchPolicy: 'network-only',
    }).pipe(
      pluck('data', 'course_registered_users_aggregate', 'aggregate', 'count')
    );
  }

}